<template>
  <div v-if="embedded" class="viz-container embedded-mode">
    <component 
      :is="activeComponent" 
      :key="activeComponent + currentKP"
      :knowledgePoint="currentKP"
    />
  </div>
  <el-drawer
    v-else
    :title="currentKP"
    :visible.sync="visible"
    size="750px"
    custom-class="premium-viz-drawer"
    :before-close="handleClose"
    direction="rtl"
    append-to-body
  >
    <div class="viz-container">
      <component 
        :is="activeComponent" 
        :key="activeComponent + currentKP"
        :knowledgePoint="currentKP"
      />
    </div>
  </el-drawer>
</template>

<script>
import AccelerationViz from './visualizations/AccelerationViz.vue';
import ACComponentViz from './visualizations/ACComponentViz.vue';
import ACGeneratorProViz from './visualizations/ACGeneratorProViz.vue';
import ACGeneratorViz from './visualizations/ACGeneratorViz.vue';
import AcousticLevitationViz from './visualizations/AcousticLevitationViz.vue';
import AcousticResonanceViz from './visualizations/AcousticResonanceViz.vue';
import ACReactanceViz from './visualizations/ACReactanceViz.vue';
import AharonovBohmEffectViz from './visualizations/AharonovBohmEffectViz.vue';
import AirResistanceViz from './visualizations/AirResistanceViz.vue';
import AlgebraicExpressionViz from './visualizations/AlgebraicExpressionViz.vue';
import AlgebraViz from './visualizations/AlgebraViz.vue';
import AlphaDecayTunnelingViz from './visualizations/AlphaDecayTunnelingViz.vue';
import AlphaRayShieldingViz from './visualizations/AlphaRayShieldingViz.vue';
import AlphaScatteringViz from './visualizations/AlphaScatteringViz.vue';
import AMGM_InequalityViz from './visualizations/AMGM_InequalityViz.vue';
import AmpereForceViz from './visualizations/AmpereForceViz.vue';
import AmpereLawViz from './visualizations/AmpereLawViz.vue';
import AngleViz from './visualizations/AngleViz.vue';
import AngularMomentumViz from './visualizations/AngularMomentumViz.vue';
import ArchimedesPrincipleViz from './visualizations/ArchimedesPrincipleViz.vue';
import AtwoodMachineViz from './visualizations/AtwoodMachineViz.vue';
import BalmerSeriesViz from './visualizations/BalmerSeriesViz.vue';
import BarkhausenEffectViz from './visualizations/BarkhausenEffectViz.vue';
import BeatPhenomenonViz from './visualizations/BeatPhenomenonViz.vue';
import BECViz from './visualizations/BECViz.vue';
import BernoulliLiftViz from './visualizations/BernoulliLiftViz.vue';
import BernoulliViz from './visualizations/BernoulliViz.vue';
import BetaDecayNeutrinoViz from './visualizations/BetaDecayNeutrinoViz.vue';
import BimetallicStripViz from './visualizations/BimetallicStripViz.vue';
import BimetallicThermometerViz from './visualizations/BimetallicThermometerViz.vue';
import BimetallicViz from './visualizations/BimetallicViz.vue';
import BiotSavartViz from './visualizations/BiotSavartViz.vue';
import BirefringenceStressViz from './visualizations/BirefringenceStressViz.vue';
import BlackbodySpectrumViz from './visualizations/BlackbodySpectrumViz.vue';
import BlackbodyViz from './visualizations/BlackbodyViz.vue';
import BlackHoleViz from './visualizations/BlackHoleViz.vue';
import BohrHydrogenViz from './visualizations/BohrHydrogenViz.vue';
import BohrModelViz from './visualizations/BohrModelViz.vue';
import BrachistochroneCurveViz from './visualizations/BrachistochroneCurveViz.vue';
import BraggDiffractionProViz from './visualizations/BraggDiffractionProViz.vue';
import BraggDiffractionViz from './visualizations/BraggDiffractionViz.vue';
import BrillouinScatteringViz from './visualizations/BrillouinScatteringViz.vue';
import BrownianMotionViz from './visualizations/BrownianMotionViz.vue';
import BubbleChamberViz from './visualizations/BubbleChamberViz.vue';
import BuoyancyViz from './visualizations/BuoyancyViz.vue';
import CalculusViz from './visualizations/CalculusViz.vue';
import CapacitorDielectricViz from './visualizations/CapacitorDielectricViz.vue';
import CapacitorViz from './visualizations/CapacitorViz.vue';
import CapillaryRiseViz from './visualizations/CapillaryRiseViz.vue';
import CapillaryViz from './visualizations/CapillaryViz.vue';
import CarnotCycleViz from './visualizations/CarnotCycleViz.vue';
import CasimirEffectViz from './visualizations/CasimirEffectViz.vue';
import CauchyInequalityViz from './visualizations/CauchyInequalityViz.vue';
import CavendishExperimentViz from './visualizations/CavendishExperimentViz.vue';
import CavitationViz from './visualizations/CavitationViz.vue';
import CenterOfMassMotionViz from './visualizations/CenterOfMassMotionViz.vue';
import CenterOfMassViz from './visualizations/CenterOfMassViz.vue';
import CevaTheoremViz from './visualizations/CevaTheoremViz.vue';
import CherenkovRadiationViz from './visualizations/CherenkovRadiationViz.vue';
import ChladniPatternsViz from './visualizations/ChladniPatternsViz.vue';
import CirclePropertiesViz from './visualizations/CirclePropertiesViz.vue';
import CircuitEquivalentViz from './visualizations/CircuitEquivalentViz.vue';
import CircularMotionViz from './visualizations/CircularMotionViz.vue';
import CloudChamberViz from './visualizations/CloudChamberViz.vue';
import CoandaEffectViz from './visualizations/CoandaEffectViz.vue';
import CoherentWaveInterferenceViz from './visualizations/CoherentWaveInterferenceViz.vue';
import CollisionTypesViz from './visualizations/CollisionTypesViz.vue';
import CollisionViz from './visualizations/CollisionViz.vue';
import CompleteQuadrilateralViz from './visualizations/CompleteQuadrilateralViz.vue';
import ComplexPlaneViz from './visualizations/ComplexPlaneViz.vue';
import ComplexPolynomialViz from './visualizations/ComplexPolynomialViz.vue';
import ComptonEffectViz from './visualizations/ComptonEffectViz.vue';
import ConcurrentForceBalanceViz from './visualizations/ConcurrentForceBalanceViz.vue';
import CongruenceSimilarityViz from './visualizations/CongruenceSimilarityViz.vue';
import CongruenceViz from './visualizations/CongruenceViz.vue';
import ConicSectionViz from './visualizations/ConicSectionViz.vue';
import CoriolisEffectViz from './visualizations/CoriolisEffectViz.vue';
import CosmicVelocityViz from './visualizations/CosmicVelocityViz.vue';
import CouetteFlowViz from './visualizations/CouetteFlowViz.vue';
import CoulombForceVectorViz from './visualizations/CoulombForceVectorViz.vue';
import CoulombLawViz from './visualizations/CoulombLawViz.vue';
import CountingPrincipleViz from './visualizations/CountingPrincipleViz.vue';
import CrystalLatticeViz from './visualizations/CrystalLatticeViz.vue';
import CurieTemperatureViz from './visualizations/CurieTemperatureViz.vue';
import CurvilinearMotionViz from './visualizations/CurvilinearMotionViz.vue';
import CycloidPendulumViz from './visualizations/CycloidPendulumViz.vue';
import CyclotronViz from './visualizations/CyclotronViz.vue';
import DavissonGermerViz from './visualizations/DavissonGermerViz.vue';
import DeBroglieMatterWaveProViz from './visualizations/DeBroglieMatterWaveProViz.vue';
import DeBroglieViz from './visualizations/DeBroglieViz.vue';
import DensityMeasurementViz from './visualizations/DensityMeasurementViz.vue';
import DiffractionGratingViz from './visualizations/DiffractionGratingViz.vue';
import DiffractionLimitViz from './visualizations/DiffractionLimitViz.vue';
import DispersionViz from './visualizations/DispersionViz.vue';
import DopplerEffectViz from './visualizations/DopplerEffectViz.vue';
import DopplerWaveShiftViz from './visualizations/DopplerWaveShiftViz.vue';
import DoubleRefractionViz from './visualizations/DoubleRefractionViz.vue';
import EarthMagneticFieldViz from './visualizations/EarthMagneticFieldViz.vue';
import EddyCurrentSortingViz from './visualizations/EddyCurrentSortingViz.vue';
import EddyCurrentViz from './visualizations/EddyCurrentViz.vue';
import EddyLevitationViz from './visualizations/EddyLevitationViz.vue';
import EddyShieldingViz from './visualizations/EddyShieldingViz.vue';
import EinsteinSpacetimeStatViz from './visualizations/EinsteinSpacetimeStatViz.vue';
import ElasticForceViz from './visualizations/ElasticForceViz.vue';
import ElectricFieldLinesViz from './visualizations/ElectricFieldLinesViz.vue';
import ElectricFieldViz from './visualizations/ElectricFieldViz.vue';
import ElectricPotentialViz from './visualizations/ElectricPotentialViz.vue';
import ElectrolyticCellViz from './visualizations/ElectrolyticCellViz.vue';
import ElectromagneticChargingViz from './visualizations/ElectromagneticChargingViz.vue';
import ElectromagneticPumpViz from './visualizations/ElectromagneticPumpViz.vue';
import ElectronDiscoveryViz from './visualizations/ElectronDiscoveryViz.vue';
import ElectronDriftViz from './visualizations/ElectronDriftViz.vue';
import ElectrostaticShieldingViz from './visualizations/ElectrostaticShieldingViz.vue';
import EMFInternalResViz from './visualizations/EMFInternalResViz.vue';
import EMSpectrumViz from './visualizations/EMSpectrumViz.vue';
import EnergyConservationViz from './visualizations/EnergyConservationViz.vue';
import EntropyViz from './visualizations/EntropyViz.vue';
import EtalonViz from './visualizations/EtalonViz.vue';
import EuclideanGCDViz from './visualizations/EuclideanGCDViz.vue';
import ExponentialFunctionViz from './visualizations/ExponentialFunctionViz.vue';
import FaradayCageViz from './visualizations/FaradayCageViz.vue';
import FaradayDiskViz from './visualizations/FaradayDiskViz.vue';
import FaradayIcePailViz from './visualizations/FaradayIcePailViz.vue';
import FaradayInductionViz from './visualizations/FaradayInductionViz.vue';
import FaradayRotationViz from './visualizations/FaradayRotationViz.vue';
import FermatPrincipleViz from './visualizations/FermatPrincipleViz.vue';
import FermiDistributionViz from './visualizations/FermiDistributionViz.vue';
import FiberOpticCommunicationViz from './visualizations/FiberOpticCommunicationViz.vue';
import FiberOpticsViz from './visualizations/FiberOpticsViz.vue';
import FieldLinesViz from './visualizations/FieldLinesViz.vue';
import FluidViscosityViz from './visualizations/FluidViscosityViz.vue';
import ForcedOscillationViz from './visualizations/ForcedOscillationViz.vue';
import ForceVectorViz from './visualizations/ForceVectorViz.vue';
import FranckHertzViz from './visualizations/FranckHertzViz.vue';
import FrictionAngleViz from './visualizations/FrictionAngleViz.vue';
import FrictionViz from './visualizations/FrictionViz.vue';
import GalileoInertialViz from './visualizations/GalileoInertialViz.vue';
import GaltonBoardViz from './visualizations/GaltonBoardViz.vue';
import GalvanometerViz from './visualizations/GalvanometerViz.vue';
import GammaDecayViz from './visualizations/GammaDecayViz.vue';
import GammaRayShieldingViz from './visualizations/GammaRayShieldingViz.vue';
import GasKineticTheoryViz from './visualizations/GasKineticTheoryViz.vue';
import GasLawViz from './visualizations/GasLawViz.vue';
import GasPressureMicroViz from './visualizations/GasPressureMicroViz.vue';
import GeneralEquilibriumViz from './visualizations/GeneralEquilibriumViz.vue';
import GenerativeAIViz from './visualizations/GenerativeAIViz.vue';
import GeometricAreaModelsViz from './visualizations/GeometricAreaModelsViz.vue';
import GeometricTransformViz from './visualizations/GeometricTransformViz.vue';
import GeometryViz from './visualizations/GeometryViz.vue';
import GravitationalLensingViz from './visualizations/GravitationalLensingViz.vue';
import GravitationalSlingshotViz from './visualizations/GravitationalSlingshotViz.vue';
import GravitationalTimeDilationViz from './visualizations/GravitationalTimeDilationViz.vue';
import GravitationalWaveViz from './visualizations/GravitationalWaveViz.vue';
import GravitationViz from './visualizations/GravitationViz.vue';
import GravityViz from './visualizations/GravityViz.vue';
import GravityWavesViz from './visualizations/GravityWavesViz.vue';
import GroupPhaseVelocityViz from './visualizations/GroupPhaseVelocityViz.vue';
import HallEffectViz from './visualizations/HallEffectViz.vue';
import HallProbeViz from './visualizations/HallProbeViz.vue';
import HarmonicRangeViz from './visualizations/HarmonicRangeViz.vue';
import HeatEngineViz from './visualizations/HeatEngineViz.vue';
import HeatWorkViz from './visualizations/HeatWorkViz.vue';
import HelmholtzResonatorViz from './visualizations/HelmholtzResonatorViz.vue';
import HertzExperimentViz from './visualizations/HertzExperimentViz.vue';
import HubbleLawExpandsViz from './visualizations/HubbleLawExpandsViz.vue';
import HubbleLawViz from './visualizations/HubbleLawViz.vue';
import HuygensPrincipleProViz from './visualizations/HuygensPrincipleProViz.vue';
import HuygensPrincipleViz from './visualizations/HuygensPrincipleViz.vue';
import HydraulicJumpViz from './visualizations/HydraulicJumpViz.vue';
import HydrogenSpectrumViz from './visualizations/HydrogenSpectrumViz.vue';
import IdealGasStateViz from './visualizations/IdealGasStateViz.vue';
import ImpulseMomentumViz from './visualizations/ImpulseMomentumViz.vue';
import InductionHeatingViz from './visualizations/InductionHeatingViz.vue';
import InductorStorageViz from './visualizations/InductorStorageViz.vue';
import InequalityViz from './visualizations/InequalityViz.vue';
import InertialForceViz from './visualizations/InertialForceViz.vue';
import InertiaViz from './visualizations/InertiaViz.vue';
import IsoscelesTrapezoidViz from './visualizations/IsoscelesTrapezoidViz.vue';
import IsoscelesTriangleViz from './visualizations/IsoscelesTriangleViz.vue';
import IsotopeHalfLifeViz from './visualizations/IsotopeHalfLifeViz.vue';
import JensenInequalityViz from './visualizations/JensenInequalityViz.vue';
import JouleLawViz from './visualizations/JouleLawViz.vue';
import KarmanVortexViz from './visualizations/KarmanVortexViz.vue';
import KelvinHelmholtzViz from './visualizations/KelvinHelmholtzViz.vue';
import KelvinWaterDropperViz from './visualizations/KelvinWaterDropperViz.vue';
import KeplerLawsViz from './visualizations/KeplerLawsViz.vue';
import KeplerLawViz from './visualizations/KeplerLawViz.vue';
import KerrEffectViz from './visualizations/KerrEffectViz.vue';
import KinematicGraphsViz from './visualizations/KinematicGraphsViz.vue';
import KineticEnergyTheoremViz from './visualizations/KineticEnergyTheoremViz.vue';
import KirchhoffLawsViz from './visualizations/KirchhoffLawsViz.vue';
import KoenigTheoremViz from './visualizations/KoenigTheoremViz.vue';
import LaminarTurbulentViz from './visualizations/LaminarTurbulentViz.vue';
import LangmuirProbeViz from './visualizations/LangmuirProbeViz.vue';
import LCDPolarizationViz from './visualizations/LCDPolarizationViz.vue';
import LCOscillationViz from './visualizations/LCOscillationViz.vue';
import LengthMeasurementViz from './visualizations/LengthMeasurementViz.vue';
import LensAberrationViz from './visualizations/LensAberrationViz.vue';
import LensesCombinationViz from './visualizations/LensesCombinationViz.vue';
import LensImagingViz from './visualizations/LensImagingViz.vue';
import LenzLawViz from './visualizations/LenzLawViz.vue';
import LeverViz from './visualizations/LeverViz.vue';
import LightLinearViz from './visualizations/LightLinearViz.vue';
import LightReflectionViz from './visualizations/LightReflectionViz.vue';
import LightRefractionViz from './visualizations/LightRefractionViz.vue';
import LimitViz from './visualizations/LimitViz.vue';
import LiquidCrystalViz from './visualizations/LiquidCrystalViz.vue';
import LiquidPressureViz from './visualizations/LiquidPressureViz.vue';
import LissajousCurvesViz from './visualizations/LissajousCurvesViz.vue';
import LobeInterferenceViz from './visualizations/LobeInterferenceViz.vue';
import LocomotiveStartupViz from './visualizations/LocomotiveStartupViz.vue';
import LogarithmicFunctionViz from './visualizations/LogarithmicFunctionViz.vue';
import LorentzContractionViz from './visualizations/LorentzContractionViz.vue';
import LorentzForceViz from './visualizations/LorentzForceViz.vue';
import MachConeViz from './visualizations/MachConeViz.vue';
import MachZehnderViz from './visualizations/MachZehnderViz.vue';
import MagdeburgViz from './visualizations/MagdeburgViz.vue';
import MagneticBrakingViz from './visualizations/MagneticBrakingViz.vue';
import MagneticFluxViz from './visualizations/MagneticFluxViz.vue';
import MagneticHysteresisViz from './visualizations/MagneticHysteresisViz.vue';
import MagneticInductionViz from './visualizations/MagneticInductionViz.vue';
import MagneticMirrorViz from './visualizations/MagneticMirrorViz.vue';
import MagnusEffectViz from './visualizations/MagnusEffectViz.vue';
import MarangoniEffectViz from './visualizations/MarangoniEffectViz.vue';
import MassSpectrometerViz from './visualizations/MassSpectrometerViz.vue';
import MassViz from './visualizations/MassViz.vue';
import MatchingViz from './visualizations/MatchingViz.vue';
import MathFunctionViz from './visualizations/MathFunctionViz.vue';
import MatterStatesViz from './visualizations/MatterStatesViz.vue';
import MaxwellsWheelViz from './visualizations/MaxwellsWheelViz.vue';
import MechanicalEfficiencyViz from './visualizations/MechanicalEfficiencyViz.vue';
import MechanicalEnergyViz from './visualizations/MechanicalEnergyViz.vue';
import MeissnerEffectViz from './visualizations/MeissnerEffectViz.vue';
import MenelausTheoremViz from './visualizations/MenelausTheoremViz.vue';
import MichelsonInterferometerViz from './visualizations/MichelsonInterferometerViz.vue';
import MillikanOilDropViz from './visualizations/MillikanOilDropViz.vue';
import MillikanViz from './visualizations/MillikanViz.vue';
import MolecularForceViz from './visualizations/MolecularForceViz.vue';
import MomentOfInertiaViz from './visualizations/MomentOfInertiaViz.vue';
import MomentumConservationProViz from './visualizations/MomentumConservationProViz.vue';
import MomentumConservationViz from './visualizations/MomentumConservationViz.vue';
import MotionDescriptionViz from './visualizations/MotionDescriptionViz.vue';
import MotorPrincipleViz from './visualizations/MotorPrincipleViz.vue';
import MutualInductionViz from './visualizations/MutualInductionViz.vue';
import NeutrinoOscillationViz from './visualizations/NeutrinoOscillationViz.vue';
import NeutronStarViz from './visualizations/NeutronStarViz.vue';
import NewtonFirstLawViz from './visualizations/NewtonFirstLawViz.vue';
import NewtonRingsViz from './visualizations/NewtonRingsViz.vue';
import NewtonSecondLawViz from './visualizations/NewtonSecondLawViz.vue';
import NewtonThirdLawViz from './visualizations/NewtonThirdLawViz.vue';
import NonNewtonianViz from './visualizations/NonNewtonianViz.vue';
import NuclearBindingViz from './visualizations/NuclearBindingViz.vue';
import NuclearChainReactionViz from './visualizations/NuclearChainReactionViz.vue';
import NuclearDecayViz from './visualizations/NuclearDecayViz.vue';
import NuclearFissionChainViz from './visualizations/NuclearFissionChainViz.vue';
import NuclearFissionViz from './visualizations/NuclearFissionViz.vue';
import NuclearFusionViz from './visualizations/NuclearFusionViz.vue';
import NuclearMagneticResonanceViz from './visualizations/NuclearMagneticResonanceViz.vue';
import NuclearShieldingViz from './visualizations/NuclearShieldingViz.vue';
import NuclearStabilityViz from './visualizations/NuclearStabilityViz.vue';
import NumberLineViz from './visualizations/NumberLineViz.vue';
import NumberSequenceViz from './visualizations/NumberSequenceViz.vue';
import NumberTheoryViz from './visualizations/NumberTheoryViz.vue';
import OhmLawViz from './visualizations/OhmLawViz.vue';
import OpticalTweezersViz from './visualizations/OpticalTweezersViz.vue';
import OpticsRefractionViz from './visualizations/OpticsRefractionViz.vue';
import ParallelLinesViz from './visualizations/ParallelLinesViz.vue';
import ParallelogramViz from './visualizations/ParallelogramViz.vue';
import ParticleBoxViz from './visualizations/ParticleBoxViz.vue';
import ParticleViz from './visualizations/ParticleViz.vue';
import PascalPrincipleViz from './visualizations/PascalPrincipleViz.vue';
import PauliExclusionViz from './visualizations/PauliExclusionViz.vue';
import PeltierEffectViz from './visualizations/PeltierEffectViz.vue';
import PendingViz from './visualizations/PendingViz.vue';
import PhaseDiagramViz from './visualizations/PhaseDiagramViz.vue';
import PhotoelectricCurrentViz from './visualizations/PhotoelectricCurrentViz.vue';
import PhotoelectricEffectViz from './visualizations/PhotoelectricEffectViz.vue';
import PhotoelectricViz from './visualizations/PhotoelectricViz.vue';
import PhotoelectricWorkFunctionProViz from './visualizations/PhotoelectricWorkFunctionProViz.vue';
import PhysicsConstantsViz from './visualizations/PhysicsConstantsViz.vue';
import PiezoelectricEffectViz from './visualizations/PiezoelectricEffectViz.vue';
import PiezoelectricLighterViz from './visualizations/PiezoelectricLighterViz.vue';
import PinchEffectViz from './visualizations/PinchEffectViz.vue';
import PlaneMirrorImagingViz from './visualizations/PlaneMirrorImagingViz.vue';
import PolarizationMalusProViz from './visualizations/PolarizationMalusProViz.vue';
import PolarizationViz from './visualizations/PolarizationViz.vue';
import PolynomialViz from './visualizations/PolynomialViz.vue';
import PotentialWellViz from './visualizations/PotentialWellViz.vue';
import PowerFunctionViz from './visualizations/PowerFunctionViz.vue';
import PowerOfPointViz from './visualizations/PowerOfPointViz.vue';
import PoyntingVectorViz from './visualizations/PoyntingVectorViz.vue';
import PressureViz from './visualizations/PressureViz.vue';
import PrismViz from './visualizations/PrismViz.vue';
import ProbabilityViz from './visualizations/ProbabilityViz.vue';
import ProjectileMotionProViz from './visualizations/ProjectileMotionProViz.vue';
import ProjectileMotionViz from './visualizations/ProjectileMotionViz.vue';
import PulleySystemViz from './visualizations/PulleySystemViz.vue';
import PythagoreanTheoremViz from './visualizations/PythagoreanTheoremViz.vue';
import QuadrilateralViz from './visualizations/QuadrilateralViz.vue';
import QuantumStateSuperpositionProViz from './visualizations/QuantumStateSuperpositionProViz.vue';
import QuantumSuperpositionViz from './visualizations/QuantumSuperpositionViz.vue';
import QuantumTunnelingViz from './visualizations/QuantumTunnelingViz.vue';
import RadioactiveDecayViz from './visualizations/RadioactiveDecayViz.vue';
import RamanScatteringViz from './visualizations/RamanScatteringViz.vue';
import RayleighScatteringViz from './visualizations/RayleighScatteringViz.vue';
import RayleighTaylorViz from './visualizations/RayleighTaylorViz.vue';
import RectangleViz from './visualizations/RectangleViz.vue';
import ReferenceFrameViz from './visualizations/ReferenceFrameViz.vue';
import RelativeMotionViz from './visualizations/RelativeMotionViz.vue';
import RelativityViz from './visualizations/RelativityViz.vue';
import ResistanceLawViz from './visualizations/ResistanceLawViz.vue';
import ResonanceViz from './visualizations/ResonanceViz.vue';
import ResonantCircuitViz from './visualizations/ResonantCircuitViz.vue';
import RhombusViz from './visualizations/RhombusViz.vue';
import RightHandRuleViz from './visualizations/RightHandRuleViz.vue';
import RightTriangleViz from './visualizations/RightTriangleViz.vue';
import RigidBodyViz from './visualizations/RigidBodyViz.vue';
import RigidEquilibriumViz from './visualizations/RigidEquilibriumViz.vue';
import RootsOfUnityViz from './visualizations/RootsOfUnityViz.vue';
import RubberHysteresisViz from './visualizations/RubberHysteresisViz.vue';
import RubensTubeViz from './visualizations/RubensTubeViz.vue';
import RutherfordModelViz from './visualizations/RutherfordModelViz.vue';
import ScanningTunnelingViz from './visualizations/ScanningTunnelingViz.vue';
import SchlierenViz from './visualizations/SchlierenViz.vue';
import ScientificBlueprintViz from './visualizations/ScientificBlueprintViz.vue';
import SeebeckEffectViz from './visualizations/SeebeckEffectViz.vue';
import SeismographPrincipleViz from './visualizations/SeismographPrincipleViz.vue';
import SelfInductionViz from './visualizations/SelfInductionViz.vue';
import SemanticGenerativeEngine from './visualizations/SemanticGenerativeEngine.vue';
import SemiconductorPNViz from './visualizations/SemiconductorPNViz.vue';
import SeriesParallelViz from './visualizations/SeriesParallelViz.vue';
import SetTheoryViz from './visualizations/SetTheoryViz.vue';
import SHMDescriptionViz from './visualizations/SHMDescriptionViz.vue';
import ShockWaveReflectionViz from './visualizations/ShockWaveReflectionViz.vue';
import SimilarTrianglesViz from './visualizations/SimilarTrianglesViz.vue';
import SimpleHarmonicMotionViz from './visualizations/SimpleHarmonicMotionViz.vue';
import SimplePendulumViz from './visualizations/SimplePendulumViz.vue';
import SimsonLineViz from './visualizations/SimsonLineViz.vue';
import SolarCellViz from './visualizations/SolarCellViz.vue';
import SolarSystemScaleViz from './visualizations/SolarSystemScaleViz.vue';
import SolidGeometryViz from './visualizations/SolidGeometryViz.vue';
import SonicBoomViz from './visualizations/SonicBoomViz.vue';
import SoundDopplerViz from './visualizations/SoundDopplerViz.vue';
import SoundSpeedMediaViz from './visualizations/SoundSpeedMediaViz.vue';
import SoundWaveViz from './visualizations/SoundWaveViz.vue';
import SpaceGeometryViz from './visualizations/SpaceGeometryViz.vue';
import SpecialTriangleViz from './visualizations/SpecialTriangleViz.vue';
import SpecificHeatViz from './visualizations/SpecificHeatViz.vue';
import SquareViz from './visualizations/SquareViz.vue';
import StabilityViz from './visualizations/StabilityViz.vue';
import StackEffectViz from './visualizations/StackEffectViz.vue';
import StandardModelQuarksViz from './visualizations/StandardModelQuarksViz.vue';
import StandardModelViz from './visualizations/StandardModelViz.vue';
import StandingWaveViz from './visualizations/StandingWaveViz.vue';
import StefanBoltzmannViz from './visualizations/StefanBoltzmannViz.vue';
import StepDownTransformerViz from './visualizations/StepDownTransformerViz.vue';
import SternGerlachViz from './visualizations/SternGerlachViz.vue';
import STMImagingViz from './visualizations/STMImagingViz.vue';
import ST_GraphViz from './visualizations/ST_GraphViz.vue';
import SuperconductivityViz from './visualizations/SuperconductivityViz.vue';
import SurfaceTensionViz from './visualizations/SurfaceTensionViz.vue';
import SymmetryViz from './visualizations/SymmetryViz.vue';
import TeslaCoilViz from './visualizations/TeslaCoilViz.vue';
import ThermalConductionViz from './visualizations/ThermalConductionViz.vue';
import ThermalElectricalCondViz from './visualizations/ThermalElectricalCondViz.vue';
import ThermodynamicsFirstLawViz from './visualizations/ThermodynamicsFirstLawViz.vue';
import ThinFilmInterferenceViz from './visualizations/ThinFilmInterferenceViz.vue';
import TokamakFusionViz from './visualizations/TokamakFusionViz.vue';
import TorqueViz from './visualizations/TorqueViz.vue';
import TorricelliLawViz from './visualizations/TorricelliLawViz.vue';
import TotalInternalReflectionViz from './visualizations/TotalInternalReflectionViz.vue';
import TotalReflectionViz from './visualizations/TotalReflectionViz.vue';
import TransformerViz from './visualizations/TransformerViz.vue';
import TrapezoidViz from './visualizations/TrapezoidViz.vue';
import TriangleCentersViz from './visualizations/TriangleCentersViz.vue';
import TrianglePropertiesViz from './visualizations/TrianglePropertiesViz.vue';
import TrigFunctionViz from './visualizations/TrigFunctionViz.vue';
import TrigSeriesViz from './visualizations/TrigSeriesViz.vue';
import TyndallScatteringViz from './visualizations/TyndallScatteringViz.vue';
import UncertaintyViz from './visualizations/UncertaintyViz.vue';
import VAMethodViz from './visualizations/VAMethodViz.vue';
import VanDeGraaffViz from './visualizations/VanDeGraaffViz.vue';
import VanDerWaalsForceViz from './visualizations/VanDerWaalsForceViz.vue';
import VariableForceWorkViz from './visualizations/VariableForceWorkViz.vue';
import VectorGeometryViz from './visualizations/VectorGeometryViz.vue';
import VelocityViz from './visualizations/VelocityViz.vue';
import VenturiEffectViz from './visualizations/VenturiEffectViz.vue';
import VT_GraphViz from './visualizations/VT_GraphViz.vue';
import WaterStreamLightGuideViz from './visualizations/WaterStreamLightGuideViz.vue';
import WaveDiffractionSlitViz from './visualizations/WaveDiffractionSlitViz.vue';
import WaveInterferenceViz from './visualizations/WaveInterferenceViz.vue';
import WaveOpticsViz from './visualizations/WaveOpticsViz.vue';
import WaveReflectionViz from './visualizations/WaveReflectionViz.vue';
import WaveVibrationViz from './visualizations/WaveVibrationViz.vue';
import WeightlessnessViz from './visualizations/WeightlessnessViz.vue';
import WheatstoneBridgeViz from './visualizations/WheatstoneBridgeViz.vue';
import WiensLawViz from './visualizations/WiensLawViz.vue';
import WimshurstMachineViz from './visualizations/WimshurstMachineViz.vue';
import WollastonPrismViz from './visualizations/WollastonPrismViz.vue';
import WorkEnergyPrincipleViz from './visualizations/WorkEnergyPrincipleViz.vue';
import WorkPowerViz from './visualizations/WorkPowerViz.vue';
import WorkRelativityViz from './visualizations/WorkRelativityViz.vue';
import XRayDiffractionViz from './visualizations/XRayDiffractionViz.vue';
import YoungsDoubleSlitProViz from './visualizations/YoungsDoubleSlitProViz.vue';
import YoungsDoubleSlitViz from './visualizations/YoungsDoubleSlitViz.vue';
import ZeemanEffectViz from './visualizations/ZeemanEffectViz.vue';
import ZeemanSplitProViz from './visualizations/ZeemanSplitProViz.vue';
import ZenerDiodeViz from './visualizations/ZenerDiodeViz.vue';

export default {
  name: 'KnowledgeVisualization',
  components: {
    AccelerationViz,
    ACComponentViz,
    ACGeneratorProViz,
    ACGeneratorViz,
    AcousticLevitationViz,
    AcousticResonanceViz,
    ACReactanceViz,
    AharonovBohmEffectViz,
    AirResistanceViz,
    AlgebraicExpressionViz,
    AlgebraViz,
    AlphaDecayTunnelingViz,
    AlphaRayShieldingViz,
    AlphaScatteringViz,
    AMGM_InequalityViz,
    AmpereForceViz,
    AmpereLawViz,
    AngleViz,
    AngularMomentumViz,
    ArchimedesPrincipleViz,
    AtwoodMachineViz,
    BalmerSeriesViz,
    BarkhausenEffectViz,
    BeatPhenomenonViz,
    BECViz,
    BernoulliLiftViz,
    BernoulliViz,
    BetaDecayNeutrinoViz,
    BimetallicStripViz,
    BimetallicThermometerViz,
    BimetallicViz,
    BiotSavartViz,
    BirefringenceStressViz,
    BlackbodySpectrumViz,
    BlackbodyViz,
    BlackHoleViz,
    BohrHydrogenViz,
    BohrModelViz,
    BrachistochroneCurveViz,
    BraggDiffractionProViz,
    BraggDiffractionViz,
    BrillouinScatteringViz,
    BrownianMotionViz,
    BubbleChamberViz,
    BuoyancyViz,
    CalculusViz,
    CapacitorDielectricViz,
    CapacitorViz,
    CapillaryRiseViz,
    CapillaryViz,
    CarnotCycleViz,
    CasimirEffectViz,
    CauchyInequalityViz,
    CavendishExperimentViz,
    CavitationViz,
    CenterOfMassMotionViz,
    CenterOfMassViz,
    CevaTheoremViz,
    CherenkovRadiationViz,
    ChladniPatternsViz,
    CirclePropertiesViz,
    CircuitEquivalentViz,
    CircularMotionViz,
    CloudChamberViz,
    CoandaEffectViz,
    CoherentWaveInterferenceViz,
    CollisionTypesViz,
    CollisionViz,
    CompleteQuadrilateralViz,
    ComplexPlaneViz,
    ComplexPolynomialViz,
    ComptonEffectViz,
    ConcurrentForceBalanceViz,
    CongruenceSimilarityViz,
    CongruenceViz,
    ConicSectionViz,
    CoriolisEffectViz,
    CosmicVelocityViz,
    CouetteFlowViz,
    CoulombForceVectorViz,
    CoulombLawViz,
    CountingPrincipleViz,
    CrystalLatticeViz,
    CurieTemperatureViz,
    CurvilinearMotionViz,
    CycloidPendulumViz,
    CyclotronViz,
    DavissonGermerViz,
    DeBroglieMatterWaveProViz,
    DeBroglieViz,
    DensityMeasurementViz,
    DiffractionGratingViz,
    DiffractionLimitViz,
    DispersionViz,
    DopplerEffectViz,
    DopplerWaveShiftViz,
    DoubleRefractionViz,
    EarthMagneticFieldViz,
    EddyCurrentSortingViz,
    EddyCurrentViz,
    EddyLevitationViz,
    EddyShieldingViz,
    EinsteinSpacetimeStatViz,
    ElasticForceViz,
    ElectricFieldLinesViz,
    ElectricFieldViz,
    ElectricPotentialViz,
    ElectrolyticCellViz,
    ElectromagneticChargingViz,
    ElectromagneticPumpViz,
    ElectronDiscoveryViz,
    ElectronDriftViz,
    ElectrostaticShieldingViz,
    EMFInternalResViz,
    EMSpectrumViz,
    EnergyConservationViz,
    EntropyViz,
    EtalonViz,
    EuclideanGCDViz,
    ExponentialFunctionViz,
    FaradayCageViz,
    FaradayDiskViz,
    FaradayIcePailViz,
    FaradayInductionViz,
    FaradayRotationViz,
    FermatPrincipleViz,
    FermiDistributionViz,
    FiberOpticCommunicationViz,
    FiberOpticsViz,
    FieldLinesViz,
    FluidViscosityViz,
    ForcedOscillationViz,
    ForceVectorViz,
    FranckHertzViz,
    FrictionAngleViz,
    FrictionViz,
    GalileoInertialViz,
    GaltonBoardViz,
    GalvanometerViz,
    GammaDecayViz,
    GammaRayShieldingViz,
    GasKineticTheoryViz,
    GasLawViz,
    GasPressureMicroViz,
    GeneralEquilibriumViz,
    GenerativeAIViz,
    GeometricAreaModelsViz,
    GeometricTransformViz,
    GeometryViz,
    GravitationalLensingViz,
    GravitationalSlingshotViz,
    GravitationalTimeDilationViz,
    GravitationalWaveViz,
    GravitationViz,
    GravityViz,
    GravityWavesViz,
    GroupPhaseVelocityViz,
    HallEffectViz,
    HallProbeViz,
    HarmonicRangeViz,
    HeatEngineViz,
    HeatWorkViz,
    HelmholtzResonatorViz,
    HertzExperimentViz,
    HubbleLawExpandsViz,
    HubbleLawViz,
    HuygensPrincipleProViz,
    HuygensPrincipleViz,
    HydraulicJumpViz,
    HydrogenSpectrumViz,
    IdealGasStateViz,
    ImpulseMomentumViz,
    InductionHeatingViz,
    InductorStorageViz,
    InequalityViz,
    InertialForceViz,
    InertiaViz,
    IsoscelesTrapezoidViz,
    IsoscelesTriangleViz,
    IsotopeHalfLifeViz,
    JensenInequalityViz,
    JouleLawViz,
    KarmanVortexViz,
    KelvinHelmholtzViz,
    KelvinWaterDropperViz,
    KeplerLawsViz,
    KeplerLawViz,
    KerrEffectViz,
    KinematicGraphsViz,
    KineticEnergyTheoremViz,
    KirchhoffLawsViz,
    KoenigTheoremViz,
    LaminarTurbulentViz,
    LangmuirProbeViz,
    LCDPolarizationViz,
    LCOscillationViz,
    LengthMeasurementViz,
    LensAberrationViz,
    LensesCombinationViz,
    LensImagingViz,
    LenzLawViz,
    LeverViz,
    LightLinearViz,
    LightReflectionViz,
    LightRefractionViz,
    LimitViz,
    LiquidCrystalViz,
    LiquidPressureViz,
    LissajousCurvesViz,
    LobeInterferenceViz,
    LocomotiveStartupViz,
    LogarithmicFunctionViz,
    LorentzContractionViz,
    LorentzForceViz,
    MachConeViz,
    MachZehnderViz,
    MagdeburgViz,
    MagneticBrakingViz,
    MagneticFluxViz,
    MagneticHysteresisViz,
    MagneticInductionViz,
    MagneticMirrorViz,
    MagnusEffectViz,
    MarangoniEffectViz,
    MassSpectrometerViz,
    MassViz,
    MatchingViz,
    MathFunctionViz,
    MatterStatesViz,
    MaxwellsWheelViz,
    MechanicalEfficiencyViz,
    MechanicalEnergyViz,
    MeissnerEffectViz,
    MenelausTheoremViz,
    MichelsonInterferometerViz,
    MillikanOilDropViz,
    MillikanViz,
    MolecularForceViz,
    MomentOfInertiaViz,
    MomentumConservationProViz,
    MomentumConservationViz,
    MotionDescriptionViz,
    MotorPrincipleViz,
    MutualInductionViz,
    NeutrinoOscillationViz,
    NeutronStarViz,
    NewtonFirstLawViz,
    NewtonRingsViz,
    NewtonSecondLawViz,
    NewtonThirdLawViz,
    NonNewtonianViz,
    NuclearBindingViz,
    NuclearChainReactionViz,
    NuclearDecayViz,
    NuclearFissionChainViz,
    NuclearFissionViz,
    NuclearFusionViz,
    NuclearMagneticResonanceViz,
    NuclearShieldingViz,
    NuclearStabilityViz,
    NumberLineViz,
    NumberSequenceViz,
    NumberTheoryViz,
    OhmLawViz,
    OpticalTweezersViz,
    OpticsRefractionViz,
    ParallelLinesViz,
    ParallelogramViz,
    ParticleBoxViz,
    ParticleViz,
    PascalPrincipleViz,
    PauliExclusionViz,
    PeltierEffectViz,
    PendingViz,
    PhaseDiagramViz,
    PhotoelectricCurrentViz,
    PhotoelectricEffectViz,
    PhotoelectricViz,
    PhotoelectricWorkFunctionProViz,
    PhysicsConstantsViz,
    PiezoelectricEffectViz,
    PiezoelectricLighterViz,
    PinchEffectViz,
    PlaneMirrorImagingViz,
    PolarizationMalusProViz,
    PolarizationViz,
    PolynomialViz,
    PotentialWellViz,
    PowerFunctionViz,
    PowerOfPointViz,
    PoyntingVectorViz,
    PressureViz,
    PrismViz,
    ProbabilityViz,
    ProjectileMotionProViz,
    ProjectileMotionViz,
    PulleySystemViz,
    PythagoreanTheoremViz,
    QuadrilateralViz,
    QuantumStateSuperpositionProViz,
    QuantumSuperpositionViz,
    QuantumTunnelingViz,
    RadioactiveDecayViz,
    RamanScatteringViz,
    RayleighScatteringViz,
    RayleighTaylorViz,
    RectangleViz,
    ReferenceFrameViz,
    RelativeMotionViz,
    RelativityViz,
    ResistanceLawViz,
    ResonanceViz,
    ResonantCircuitViz,
    RhombusViz,
    RightHandRuleViz,
    RightTriangleViz,
    RigidBodyViz,
    RigidEquilibriumViz,
    RootsOfUnityViz,
    RubberHysteresisViz,
    RubensTubeViz,
    RutherfordModelViz,
    ScanningTunnelingViz,
    SchlierenViz,
    ScientificBlueprintViz,
    SeebeckEffectViz,
    SeismographPrincipleViz,
    SelfInductionViz,
    SemanticGenerativeEngine,
    SemiconductorPNViz,
    SeriesParallelViz,
    SetTheoryViz,
    SHMDescriptionViz,
    ShockWaveReflectionViz,
    SimilarTrianglesViz,
    SimpleHarmonicMotionViz,
    SimplePendulumViz,
    SimsonLineViz,
    SolarCellViz,
    SolarSystemScaleViz,
    SolidGeometryViz,
    SonicBoomViz,
    SoundDopplerViz,
    SoundSpeedMediaViz,
    SoundWaveViz,
    SpaceGeometryViz,
    SpecialTriangleViz,
    SpecificHeatViz,
    SquareViz,
    StabilityViz,
    StackEffectViz,
    StandardModelQuarksViz,
    StandardModelViz,
    StandingWaveViz,
    StefanBoltzmannViz,
    StepDownTransformerViz,
    SternGerlachViz,
    STMImagingViz,
    ST_GraphViz,
    SuperconductivityViz,
    SurfaceTensionViz,
    SymmetryViz,
    TeslaCoilViz,
    ThermalConductionViz,
    ThermalElectricalCondViz,
    ThermodynamicsFirstLawViz,
    ThinFilmInterferenceViz,
    TokamakFusionViz,
    TorqueViz,
    TorricelliLawViz,
    TotalInternalReflectionViz,
    TotalReflectionViz,
    TransformerViz,
    TrapezoidViz,
    TriangleCentersViz,
    TrianglePropertiesViz,
    TrigFunctionViz,
    TrigSeriesViz,
    TyndallScatteringViz,
    UncertaintyViz,
    VAMethodViz,
    VanDeGraaffViz,
    VanDerWaalsForceViz,
    VariableForceWorkViz,
    VectorGeometryViz,
    VelocityViz,
    VenturiEffectViz,
    VT_GraphViz,
    WaterStreamLightGuideViz,
    WaveDiffractionSlitViz,
    WaveInterferenceViz,
    WaveOpticsViz,
    WaveReflectionViz,
    WaveVibrationViz,
    WeightlessnessViz,
    WheatstoneBridgeViz,
    WiensLawViz,
    WimshurstMachineViz,
    WollastonPrismViz,
    WorkEnergyPrincipleViz,
    WorkPowerViz,
    WorkRelativityViz,
    XRayDiffractionViz,
    YoungsDoubleSlitProViz,
    YoungsDoubleSlitViz,
    ZeemanEffectViz,
    ZeemanSplitProViz,
    ZenerDiodeViz
  },
  props: {
    embedded: { type: Boolean, default: false },
    kp: { type: String, default: '' }
  },
  data() {
    return {
      visible: false,
      internalKP: '',
      componentMap: {
        '运动的描述': 'SemanticGenerativeEngine',
        '物体与质点': 'ParticleViz',
        '参考系': 'SemanticGenerativeEngine',
        '速度': 'VelocityViz',
        '加速度': 'VelocityViz',
        '重力': 'GravityViz',
        '弹力': 'ElasticForceViz',
        '摩擦力': 'FrictionViz',
        '牛顿第三定律': 'NewtonSecondLawViz',
        '共点力的平衡': 'ConcurrentForceBalanceViz',
        '牛顿第一定律': 'NewtonSecondLawViz',
        '牛顿第二定律': 'NewtonSecondLawViz',
        '曲线运动': 'GeometryViz',
        '抛体运动的规律': 'GeometryViz',
        '圆周运动': 'CircularMotionViz',
        '万有引力定律': 'GravitationViz',
        '功与功率': 'WorkPowerViz',
        '动能和动能定理': 'KineticEnergyTheoremViz',
        '机械能守恒定律': 'EnergyConservationViz',
        '电荷': 'OhmLawViz',
        '库仑定律': 'SemanticGenerativeEngine',
        '电场强度': 'OhmLawViz',
        '电势能和电势': 'OhmLawViz',
        '电容器的电容': 'OhmLawViz',
        '带电粒子在电场中的运动': 'ElectricFieldViz',
        '电源和电流': 'OhmLawViz',
        '实验：导体电阻率的测量': 'GeometryViz',
        '串联电路和并联电路': 'OhmLawViz',
        '电路中的能量转化': 'OhmLawViz',
        '闭合电路的欧姆定律': 'OhmLawViz',
        '磁感线': 'GeometryViz',
        '磁感应强度': 'MagneticInductionViz',
        '磁通量': 'MagneticInductionViz',
        '电磁感应现象及应用': 'OhmLawViz',
        '动量定理': 'ImpulseMomentumViz',
        '动量守恒定律': 'MomentumConservationViz',
        '弹性碰撞和非弹性碰撞': 'CollisionTypesViz',
        '简谐运动': 'SemanticGenerativeEngine',
        '简谐运动的描述': 'SemanticGenerativeEngine',
        '光的衍射': 'LightReflectionViz',
        '波的干涉': 'WaveInterferenceViz',
        '多普勒效应': 'DopplerEffectViz',
        '光的折射': 'TotalReflectionViz',
        '全反射': 'TotalReflectionViz',
        '光的干涉': 'LightReflectionViz',
        '带电粒子在匀强磁场中的运动': 'LorentzForceViz',
        '楞次定律': 'SemanticGenerativeEngine',
        '交变电流的描述': 'ACGeneratorViz',
        '变压器': 'SemanticGenerativeEngine',
        '分子动理论的基本内容': 'SemanticGenerativeEngine',
        '固体': 'GeometryViz',
        '液体': 'GeometryViz',
        '内能及其改变': 'HeatWorkViz',
        '热力学第一定律': 'ThermodynamicsFirstLawViz',
        '能量守恒定律': 'SemanticGenerativeEngine',
        '热力学第二定律': 'EntropyViz',
        '光电效应': 'PhotoelectricEffectViz',
        '玻尔原子模型': 'BohrModelViz',
        '波粒二象性': 'DeBroglieViz',
        '原子核的组成': 'SemanticGenerativeEngine',
        '运动的相对性': 'SemanticGenerativeEngine',
        '伽利略变换': 'SemanticGenerativeEngine',
        '摩擦角': 'GeometryViz',
        '一般物体的平衡': 'GeneralEquilibriumViz',
        '惯性力': 'SemanticGenerativeEngine',
        '质心': 'GeometryViz',
        '质心运动定理': 'GeometryViz',
        '曲率半径': 'SemanticGenerativeEngine',
        '宇宙速度': 'CosmicVelocityViz',
        '变轨运行': 'SemanticGenerativeEngine',
        '拉格朗日点': 'SemanticGenerativeEngine',
        '质点系动能定理': 'KineticEnergyTheoremViz',
        '柯尼希定理': 'SemanticGenerativeEngine',
        '资用能': 'SemanticGenerativeEngine',
        '功能原理': 'WorkPowerViz',
        '角动量定理': 'GeometryViz',
        '角动量守恒定律': 'GeometryViz',
        '刚体的运动': 'GeometryViz',
        '刚体转动定理': 'GeometryViz',
        '参考圆': 'GeometryViz',
        '驻波': 'SemanticGenerativeEngine',
        '高斯定理': 'SemanticGenerativeEngine',
        '电场中的导体': 'GeometryViz',
        '电容器的连接': 'OhmLawViz',
        '基尔霍夫定律': 'SemanticGenerativeEngine',
        '电路的等效变换': 'OhmLawViz',
        '毕奥-萨伐尔定律': 'SemanticGenerativeEngine',
        '电流的磁场': 'OhmLawViz',
        '安培环路定理': 'MagneticInductionViz',
        '安培力矩': 'MagneticInductionViz',
        '磁矩': 'MagneticInductionViz',
        '感生电动势': 'OhmLawViz',
        '动生电动势': 'OhmLawViz',
        'RLC电路': 'OhmLawViz',
        '循环过程': 'SemanticGenerativeEngine',
        '费马原理': 'SemanticGenerativeEngine',
        '透镜成像': 'LightReflectionViz',
        '惠更斯原理': 'SemanticGenerativeEngine',
        '夫琅禾费衍射': 'SemanticGenerativeEngine',
        '康普顿效应': 'SemanticGenerativeEngine',
        '光压': 'LightReflectionViz',
        '相对论初步': 'SemanticGenerativeEngine',
        '质点的运动': 'SemanticGenerativeEngine',
        '直线运动及其图像': 'KinematicGraphsViz',
        '抛体运动': 'GeometryViz',
        '相对运动': 'SemanticGenerativeEngine',
        '牛顿第运动定律': 'NewtonSecondLawViz',
        '惯性离心力': 'GeometryViz',
        '力矩': 'TorqueViz',
        '刚体平衡': 'RigidEquilibriumViz',
        '虚功原理': 'WorkPowerViz',
        '冲量与动量': 'SemanticGenerativeEngine',
        '功和功率': 'WorkPowerViz',
        '动能定理': 'KineticEnergyTheoremViz',
        '万有引力作用下的运动': 'GravitationViz',
        '开普勒定律': 'SemanticGenerativeEngine',
        '天体的运动': 'GeometryViz',
        '转动惯量': 'SemanticGenerativeEngine',
        '浮力': 'SemanticGenerativeEngine',
        '简谐振动': 'SemanticGenerativeEngine',
        '横波和纵波': 'SemanticGenerativeEngine',
        '气体实验定律': 'GeometryViz',
        '理想气体状态方程': 'GeometryViz',
        '饱和气压': 'SemanticGenerativeEngine',
        '传导': 'SemanticGenerativeEngine',
        '辐射': 'SemanticGenerativeEngine',
        '热膨胀': 'SemanticGenerativeEngine',
        '场强叠加原理': 'SemanticGenerativeEngine',
        '电势和电势差': 'OhmLawViz',
        '电容器及电容': 'OhmLawViz',
        '静电能': 'OhmLawViz',
        '欧姆定律': 'OhmLawViz',
        '毕奥-萨伐尔定律': 'SemanticGenerativeEngine',
        '安培力': 'MagneticInductionViz',
        '洛伦兹力': 'SemanticGenerativeEngine',
        '自感和互感': 'SemanticGenerativeEngine',
        '自感磁能': 'MagneticInductionViz',
        '交流电的描述': 'OhmLawViz',
        '谐振电路': 'OhmLawViz',
        '交流电的功率': 'WorkPowerViz',
        '远距离输电': 'OhmLawViz',
        '光的传播': 'LightReflectionViz',
        '平面镜成像': 'PlaneMirrorImagingViz',
        '球面镜成像': 'GeometryViz',
        '薄透镜成像': 'LightReflectionViz',
        '光子的能量与动量': 'LightReflectionViz',
        '原子的核式结构': 'SemanticGenerativeEngine',
        '原子核的衰变': 'SemanticGenerativeEngine',
        '爱因斯坦假设': 'SemanticGenerativeEngine',
        '洛伦兹变换': 'SemanticGenerativeEngine',
        '相对论动量': 'SemanticGenerativeEngine',
        '相对论能量': 'SemanticGenerativeEngine',
        '解析几何': 'GeometryViz',
        '充分条件与必要条件': 'SemanticGenerativeEngine',
        '全称量词与存在量词': 'SemanticGenerativeEngine',
        '等式的性质与不等式性质': 'SemanticGenerativeEngine',
        '函数的概念和性质': 'SemanticGenerativeEngine',
        '函数的概念及其表示': 'SemanticGenerativeEngine',
        '函数的基本性质': 'SemanticGenerativeEngine',
        '幂函数': 'SemanticGenerativeEngine',
        '指数函数': 'SemanticGenerativeEngine',
        '对数函数': 'SemanticGenerativeEngine',
        '函数的零点和方程的解': 'SemanticGenerativeEngine',
        '三角函数的图象和性质': 'GeometryViz',
        '两角和与差的三角函数': 'GeometryViz',
        '数列的一般概念': 'SemanticGenerativeEngine',
        '复数的概念': 'SemanticGenerativeEngine',
        '复数的四则运算': 'SemanticGenerativeEngine',
        '复数的三角形式': 'TrianglePropertiesViz',
        '基本立体图形': 'GeometryViz',
        '向量法解立体几何问题的基本模型': 'GeometryViz',
        '圆的方程': 'GeometryViz',
        '直线与圆、圆与圆的位置关系': 'GeometryViz',
        '分类加法计数原理与分步乘法计数原理': 'SemanticGenerativeEngine',
        '排列与组合': 'SemanticGenerativeEngine',
        '条件概率与全概率公式': 'SemanticGenerativeEngine',
        '集合运算': 'SemanticGenerativeEngine',
        '集合的覆盖与划分': 'SemanticGenerativeEngine',
        '集合的简单的组合分析': 'SemanticGenerativeEngine',
        '函数的概念 and 性质': 'SemanticGenerativeEngine',
        '反三角函数': 'GeometryViz',
        '简单的三角方程': 'GeometryViz',
        '函数方程': 'SemanticGenerativeEngine',
        '均值不等式和柯西不等式': 'SemanticGenerativeEngine',
        '凸函数的琴森不等式': 'SemanticGenerativeEngine',
        '等差数列和等比数列': 'SemanticGenerativeEngine',
        '数列的极限': 'SemanticGenerativeEngine',
        '递推法求通项公式': 'SemanticGenerativeEngine',
        '递推数列的单调性和有界性': 'SemanticGenerativeEngine',
        '向量的概念与运算': 'SemanticGenerativeEngine',
        '向量基本定理和应用': 'SemanticGenerativeEngine',
        '奔驰定理与三角形五心': 'TrianglePropertiesViz',
        '三角变换与解三角形': 'TrianglePropertiesViz',
        '复数运算的几何意义及应用': 'GeometryViz',
        '复数集内解方程': 'SemanticGenerativeEngine',
        '函数的极限和连续': 'SemanticGenerativeEngine',
        '立体几何的基本问题': 'GeometryViz',
        '圆锥曲线和直线的参数方程': 'GeometryViz',
        '圆锥曲线的极点极线': 'GeometryViz',
        '圆锥曲线的特定性质': 'GeometryViz',
        '整除的基本性质与奇偶性分析': 'SemanticGenerativeEngine',
        '同余和剩余类': 'SemanticGenerativeEngine',
        '数论的三个定理（欧拉定理、费马小定理、威尔逊定理）': 'SemanticGenerativeEngine',
        '完全平方数': 'SemanticGenerativeEngine',
        '不定方程': 'SemanticGenerativeEngine',
        '组合计数的基本原理': 'SemanticGenerativeEngine',
        '集合的划分和覆盖': 'SemanticGenerativeEngine',
        '函数迭代': 'SemanticGenerativeEngine',
        '三角函数恒等变换': 'GeometryViz',
        '三角形中的三角变换': 'TrianglePropertiesViz',
        '反三角函数和简单的三角方程': 'GeometryViz',
        '比较法 and 放缩法': 'SemanticGenerativeEngine',
        '复数的模与幅角': 'GeometryViz',
        '复数与方程': 'SemanticGenerativeEngine',
        '高阶等差数列与差分方法': 'SemanticGenerativeEngine',
        '斐波那契数列': 'SemanticGenerativeEngine',
        '递推数列和周期数列': 'SemanticGenerativeEngine',
        '圆锥曲线的方程 and 应用': 'GeometryViz',
        '坐标系的平移和旋转的应用': 'GeometryViz',
        '二次曲线族': 'GeometryViz',
        '极坐标系及其应用': 'SemanticGenerativeEngine',
        '参数方程及其应用': 'SemanticGenerativeEngine',
        '三角形的五心': 'TrianglePropertiesViz',
        '反射变换': 'LightReflectionViz',
        '调和点列': 'GeometryViz',
        '求解不定方程的基本方法': 'SemanticGenerativeEngine',
        '温度': 'SemanticGenerativeEngine',
        '质量的测量': 'SemanticGenerativeEngine',
        '密度': 'DensityMeasurementViz',
        '密度与社会生活': 'DensityMeasurementViz',
        '长度的测量': 'SemanticGenerativeEngine',
        '力的三要素': 'SemanticGenerativeEngine',
        '力的表示': 'SemanticGenerativeEngine',
        '力的相互性': 'SemanticGenerativeEngine',
        '二力平衡': 'SemanticGenerativeEngine',
        '惯性': 'SemanticGenerativeEngine',
        '固体压强': 'GeometryViz',
        '液体压强': 'GeometryViz',
        '流体压强与流速的关系': 'GeometryViz',
        '大气压强': 'PressureViz',
        '杠杆及其平衡': 'LeverViz',
        '阿基米德原理': 'ArchimedesPrincipleViz',
        '声音的产生与传播': 'SoundWaveViz',
        '声的利用': 'SoundWaveViz',
        '光的直线传播': 'GeometryViz',
        '光的反射': 'LightReflectionViz',
        '透镜': 'LightReflectionViz',
        '功': 'WorkPowerViz',
        '功率': 'WorkPowerViz',
        '机械效率': 'SemanticGenerativeEngine',
        '内能和热量': 'SemanticGenerativeEngine',
        '比热容': 'SemanticGenerativeEngine',
        '热机': 'SemanticGenerativeEngine',
        '电流及其测量': 'OhmLawViz',
        '串联和并联': 'SeriesParallelViz',
        '测量时间': 'SemanticGenerativeEngine',
        '测量物体运动的速度': 'GeometryViz',
        '探究平面镜成像的特点': 'GeometryViz',
        '标量与矢量': 'ForceVectorViz',
        '速度图像': 'KinematicGraphsViz',
        '重力与万有引力': 'GravitationViz',
        '共点力平衡': 'ConcurrentForceBalanceViz',
        '力的合成': 'ForceVectorViz',
        '力的分解': 'ForceVectorViz',
        '连通器与液压机': 'SemanticGenerativeEngine',
        '变力做功的计算': 'VariableForceWorkViz',
        '滑轮 and 滑轮组': 'PulleySystemViz',
        '电流的微观表达': 'OhmLawViz',
        '光的全反射': 'LightReflectionViz',
        '透镜成像公式': 'LightReflectionViz',
        '热平衡方程': 'SemanticGenerativeEngine',
        '有理数的意义和比较大小': 'SemanticGenerativeEngine',
        '相反数、绝对': 'SemanticGenerativeEngine',
        '数量关系的代数式表示与代数式求值': 'SemanticGenerativeEngine',
        '整式的加减乘除运算': 'SemanticGenerativeEngine',
        '因式分解（提公因式法、公式法进行因式分解）': 'SemanticGenerativeEngine',
        '乘法公式（两数平方差公式和完全平方公式）': 'SemanticGenerativeEngine',
        '全等三角形的判定定理和性质定理': 'TrianglePropertiesViz',
        '等腰三角形、直角三角形的性质定理与判定定理': 'TrianglePropertiesViz',
        '直角三角形的勾股定理及其逆定理': 'TrianglePropertiesViz',
        '平行四边形的判定和性质': 'SemanticGenerativeEngine',
        '矩形的判定 and 性质': 'RectangleViz',
        '正方形的判定 and 性质': 'SemanticGenerativeEngine',
        '图形的变化': 'GeometryViz',
        '图形的轴对称': 'GeometryViz',
        '比例的基本性质、线段的比与成比例的线段': 'GeometryViz',
        '平行线分线段成比例定理及其逆定理': 'GeometryViz',
        '相似三角形的判定定理和性质定理': 'TrianglePropertiesViz',
        '梯形的判定 and 性质': 'GeometryViz',
        '三角形的“四心”': 'TrianglePropertiesViz',
        '奇数与偶数的性质': 'SemanticGenerativeEngine',
        '质数和合数': 'SemanticGenerativeEngine',
        '配对': 'SemanticGenerativeEngine',
        '整数的认识': 'SemanticGenerativeEngine',
        '整数的大小比较': 'SemanticGenerativeEngine',
        '小数和分数的四则运算': 'SemanticGenerativeEngine',
        '用字母表示数': 'SemanticGenerativeEngine',
        '数s的估算的应用': 'SemanticGenerativeEngine',
        '比 and 比例': 'SemanticGenerativeEngine',
        '角和角的大小': 'GeometryViz',
        '基本图形的周长和面积': 'GeometryViz',
        '图形的旋转': 'GeometryViz',
        '新定义运算下的推理': 'SemanticGenerativeEngine',
        '循环小数与分数的互化': 'SemanticGenerativeEngine',
        '分数的裂差和裂和': 'SemanticGenerativeEngine',
        '依据运算律化简运算': 'SemanticGenerativeEngine',
        '简单的数列求和问题': 'SemanticGenerativeEngine',
        '平行线的性质': 'GeometryViz',
        '勾股定理及其逆定理': 'PythagoreanTheoremViz',
        '锐角三角函数': 'GeometryViz',
        '等高模型、等底模型 and 一半模型': 'GeometryViz',
        '等积变换': 'SemanticGenerativeEngine',
        '几何模型初步': 'GeometryViz',
        '风筝模型': 'GeometryViz',
        '蝴蝶模型': 'GeometryViz',
        '燕尾模型': 'GeometryViz',
        '整除问题': 'SemanticGenerativeEngine',
        '同余问题': 'SemanticGenerativeEngine',
        '短除法与辗转相除法': 'SemanticGenerativeEngine',
        '质数的判断': 'SemanticGenerativeEngine',
        '分解质因数': 'SemanticGenerativeEngine',
        '完全平方数的素因子分布规律': 'SemanticGenerativeEngine',
        '数の进制初步认识': 'SemanticGenerativeEngine',
        '简单的不定方程及其解法': 'SemanticGenerativeEngine'
      }
    };
  },
  computed: {
    currentKP() {
      return this.kp || this.internalKP;
    },
    activeComponent() {
      const kp = (this.currentKP || '').trim();
      if (this.componentMap[kp]) return this.componentMap[kp];

      // 智能语义回退逻辑：处理复合标题或非标准命名
      if (kp.includes('引力') || kp.includes('宇宙速度') || kp.includes('轨道')) return 'CosmicVelocityViz';
      if (kp.includes('相互') || kp.includes('牛顿第三')) return 'NewtonThirdLawViz';
      if (kp.includes('重力')) return 'GravityViz';
      if (kp.includes('弹力') || kp.includes('形变')) return 'ElasticForceViz';
      if (kp.includes('摩擦')) return 'FrictionViz';
      if (kp.includes('密度') || (kp.includes('质量') && kp.includes('测量'))) return 'DensityMeasurementViz';
      if (kp.includes('要素') && kp.includes('力')) return 'ForceVectorViz';
      if (kp.includes('长度') || kp.includes('卡尺') || kp.includes('螺旋测微器')) return 'LengthMeasurementViz';
      if (kp.includes('矢量') || kp.includes('合成') || kp.includes('分解')) return 'ForceVectorViz';
      if (kp.includes('多普勒')) return 'DopplerEffectViz';
      if (kp.includes('欧姆') && kp.includes('定律')) return 'EMFInternalResViz';
      if (kp.includes('流体') || kp.includes('伯努利') || kp.includes('贝努利')) return 'BernoulliViz';
      if (kp.includes('变力') || kp.includes('微元') || kp.includes('积分')) return 'VariableForceWorkViz';

      return 'SemanticGenerativeEngine';
    }
  },
  methods: {
    open(kp) {
      this.internalKP = kp;
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.viz-container {
  height: 100%;
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  overflow-y: auto;
  box-sizing: border-box;
  color: #1e293b;
  font-family: 'PingFang SC', 'Microsoft YaHei', -apple-system, sans-serif;
  gap: 6px;
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f8fafc;
  }
  &::-webkit-scrollbar-thumb {
    background: #e2e8f0;
    border-radius: 3px;
    &:hover { background: #cbd5e1; }
  }
}

.embedded-mode {
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
  height: auto !important; 
  
  ::v-deep {
    & > div {
      height: auto !important; 
      overflow: visible !important;
    }
  }
}

::v-deep {
  .premium-viz-drawer {
    box-shadow: -20px 0 40px rgba(15, 23, 42, 0.12);
    
    .el-drawer__header { 
      color: #0f172a;
      background: #ffffff; 
      padding: 10px 16px; 
      border-bottom: 2px solid #2563eb;
      margin-bottom: 0;
      font-weight: 800;
      font-size: 15px;
      position: relative;

      span {
        display: flex;
        flex-direction: column;
        line-height: 1.4;
      }
    }

    .el-drawer__close-btn {
      color: #94a3b8;
      font-size: 22px;
      padding: 0;
      width: 36px;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      
      &:hover { 
        color: #3b82f6; 
        background: #eff6ff; 
        border-radius: 50%; 
        transform: rotate(90deg);
      }
    }

    .el-drawer__body { 
      background: #f8fafc; 
      padding: 0; 
      display: flex; 
      flex-direction: column; 
    }

    .viz-header {
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      border-left: 6px solid #2563eb !important;
      border-radius: 12px !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03) !important;
      padding: 16px 20px !important;
      margin: 12px 16px !important;
      
      .brief, .title { color: #0f172a !important; font-weight: 800 !important; font-size: 16px !important; margin-bottom: 4px !important; }
      .formula, .formula-chip { 
        color: #1e3a8a !important; 
        font-weight: 800 !important; 
        background: #eff6ff !important; 
        padding: 8px 16px !important;
        border-radius: 6px !important;
        border: 1.5px solid #bfdbfe !important;
        display: inline-block !important;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
        font-size: 18px !important;
        letter-spacing: 0.5px;
      }
      .stats span, .stat-item { color: #64748b !important; font-weight: 600 !important; font-size: 13px !important; }
    }

    .main-stage, .canvas-3d-wrapper, .stage-container, .canvas-box, .simulation-container, .simulation-stage, .main-stage-wrapper {
      background: #ffffff !important;
      border: 1.5px solid #e2e8f0 !important;
      border-radius: 12px !important;
      box-shadow: 0 4px 15px rgba(15, 23, 42, 0.02) !important;
      margin: 0 0 8px 0 !important;
      min-height: 480px !important;
      position: relative;
      flex-shrink: 0;
    }

    .micro-view, .control-panel, .bottom-controls, .control-card, .micro-card, .control-card-grid, .logic-panel, .simulation-stage {
      background: #ffffff !important;
      border: 1px solid #e2e8f0 !important;
      border-radius: 12px !important;
      padding: 10px 14px !important;
      margin: 0 0 8px 0 !important;
      flex-shrink: 0;
      overflow-y: auto !important; 

      h3, .stat-box label, label { 
        color: #0f172a !important; 
        font-weight: 800 !important; 
        margin-bottom: 8px !important;
        font-size: 15px !important;
        display: block;
      }
      
      p, span, .stat-box span, .text-content { 
        color: #475569 !important; 
        line-height: 1.6 !important;
        font-size: 14px !important;
      }
    }

    .eq-box {
      overflow: visible !important; 
    }

    .discovery-card, .notice-box, .discovery-note, .physics-detail, .discovery-card-compact, .desc-text, .physics-caption, .desc {
      background: #f8fafc !important;
      border: 1px solid #e2e8f0 !important;
      padding: 10px 14px !important;
      margin: 2px 0 6px 0 !important;
      border-radius: 10px !important;
      max-height: none !important; 
      overflow-y: visible !important; 
      flex-shrink: 0;
      flex-grow: 0; 
      
      p, .content { color: #111827 !important; font-weight: 500 !important; line-height: 1.6 !important; font-size: 13.5px !important; margin: 0; }
      strong, b { color: #000000 !important; font-weight: 900 !important; }
      i, .el-icon-info, .el-icon-warning { color: #2563eb !important; font-size: 1.25rem !important; margin-right: 6px; font-weight: 900 !important; }
    }

    .el-button {
      border-radius: 8px !important;
      height: 36px !important;
      padding: 0 16px !important;
      font-weight: 700 !important;
      font-size: 13px !important;
      
      &--primary, &--success, &.start-btn {
        background: #2563eb !important;
        border-color: #2563eb !important;
        color: #ffffff !important;
        
        span { color: #ffffff !important; }

        &:hover {
          background: #1d4ed8 !important;
          transform: translateY(-1px);
        }
      }
    }

    .el-radio-group {
      display: flex !important;
      width: 100% !important;
      flex-wrap: nowrap !important;
      margin: 4px 0 12px 0 !important;
      
      .el-radio-button {
        flex: 1 !important;
        display: flex !important;
        
        &__inner {
          width: 100% !important;
          font-weight: 700 !important;
          transition: all 0.2s ease;
          border-radius: 0 !important;
          margin: 0 !important;
          border: 1px solid #e2e8f0 !important;
          border-left: none !important;
          box-shadow: none !important;
          padding: 10px 4px !important;
          white-space: nowrap !important;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 13px !important;
          display: flex !important;
          align-items: center;
          justify-content: center;
          
          &:hover { color: #2563eb; background: #f8fafc; }
        }

        &:first-child .el-radio-button__inner {
          border-left: 1px solid #e2e8f0 !important;
          border-top-left-radius: 8px !important;
          border-bottom-left-radius: 8px !important;
        }

        &:last-child .el-radio-button__inner {
          border-top-right-radius: 8px !important;
          border-bottom-right-radius: 8px !important;
        }

        &.is-active .el-radio-button__inner {
          background-color: #2563eb !important;
          border-color: #2563eb !important;
          color: #ffffff !important;
          box-shadow: 0 2px 6px rgba(37, 99, 235, 0.15) !important;
          z-index: 1;
        }
      }
    }

    .visualization-viewer {
      display: flex;
      flex-direction: column;
      height: 100%;
      min-height: 480px;
    }
  }
}
</style>
